import { MentorMessageBubble } from './MentorMessagesService';
import { formatMessageTime } from './mentorMessagesFormat';

type Props = {
    menteeName: string | null;
    messages: MentorMessageBubble[];
    loading: boolean;
    error: string | null;

    
};

const getInitials = (name: string) => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
};

const MentorMessagesThread = ({ menteeName, messages, loading, error }: Props) => (
    <>
        <div className="p-3 border-bottom bg-white d-flex align-items-center">
            <div className="d-flex align-items-center gap-2">
                <span
                    className="rounded-circle border border-primary border-opacity-25 flex-shrink-0 bg-primary-subtle text-primary d-flex align-items-center justify-content-center font-600"
                    id="chat-header-av"
                    style={{ width: '36px', height: '36px' }}>
                    {menteeName ? getInitials(menteeName) : 'C'}
                </span>
                <div>
                    <div className="fw-bold text-dark font-14" id="chat-header-name">
                        {menteeName || 'Conversation'}
                    </div>
                    <div className="text-secondary font-11" id="chat-header-sub">
                        MBA Year 2 · Delhi · Consulting &amp; Strategy
                    </div>
                </div>
            </div>
        </div>
        <div className="p-3 d-flex flex-column-reverse gap-3 overflow-y-auto flex-grow-1" id="chat-thread-container" style={{maxHeight: '385px'}}>
            <div className='d-flex flex-column gap-3'>
                <div className="text-center">
                    <span className="badge bg-light border border-light-subtle text-secondary font-11 fw-normal py-1 px-3 rounded-pill">Mentorship started · June 22, 2025 · Pairing published</span>
                </div>
                <div className="text-center">
                    <span className="badge bg-success bg-opacity-10 text-success font-11 fw-normal py-1 px-3 rounded-pill border border-success border-opacity-25">Arjun has been introduced to you as his mentor</span>
                </div>
            </div>
            
            {loading ? <p className="mmmsg-muted">Loading…</p> : null}
            {!loading && error ? <p className="mmmsg-error">{error}</p> : null}
            {!loading && !error && messages.length === 0 ? <p className="mmmsg-empty-thread">No messages yet — say hello</p> : null}
            {!loading && !error && messages.length > 0 ? (
                <>
                    {[...messages].reverse().map((message, index) => {
                        const timeLabel = formatMessageTime(message.sentDate);
                        const mine = message.isFromCurrentUser;
                        return (
                            <div
                                key={message.id ?? `${message.sentDate || 'row'}-${index}`}
                                className={`d-flex flex-column  ${mine ? ' align-self-end' : ' align-self-start'}`}>
                                    
                                <div className={` rounded-3 rounded-bottom-start-0 font-13 shadow-sm ${mine ? 'bg-white text-dark p-3 border border-light-subtle' : 'bg-primary text-white p-3 border-0'}`}>{message.body}</div>
                                {timeLabel ? <div className="text-muted font-10 mt-1">{timeLabel}</div> : null}
                            </div>
                        );
                    })}
                </>
            ) : null}
        </div>
    </>
);

export default MentorMessagesThread;
